import { render } from "./Node.vue?vue&type=template&id=6c4ea970&scoped=true&ts=true"
import script from "./Node.vue?vue&type=script&lang=ts"
export * from "./Node.vue?vue&type=script&lang=ts"

import "./Node.vue?vue&type=style&index=0&id=6c4ea970&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4ea970"]])

export default __exports__